import { CreateSendEmail } from './email.types';

export const createSendEmail: CreateSendEmail = body => ({
  endpoint: '/virtual-graduation/participant/email-recovery',
  method: 'POST',
  body,
});
